export const CHAT_LINK =
  "https://calendly.com/bb-datashare/datashare-intro-call";
